export default __webpack_public_path__ + "static/media/underMaintenancev3.9185509f.jpg";